import React, { memo } from 'react';
import { Dialog, DialogActions, DialogContent, Typography } from '@material-ui/core';
import { Button, BUTTON } from 'components/common/Button/Button';
import ReportDialogTitle from 'pages/report/components/ReportDialogTitle';
import { dataSourceActions, dataSourceStatus } from '../utils/constants';
import styles from 'pages/report/components/ReportDialogs.scss';

const DialogDataSource = ({ dialogOpen, rowSelected, toggleDialog, onConfirm }) => {
    const isInactive = rowSelected.status === dataSourceStatus.inactive.value;
    const dialogTitle = `${isInactive ? dataSourceActions.restore : dataSourceActions.deactivate} ${rowSelected.text}`;
    const dialogContent = `${
        isInactive
            ? 'This will restore this data source item and make it available for use again. '
            : 'Deactivating this data source item will not remove it from any binder setup pages or documents where it has been attached. This data source item can also be reactivated.'
    }`;
    const dialogConfirm = isInactive ? dataSourceActions.restore : dataSourceActions.deactivate;

    const onClick = () => {
        onConfirm();
        toggleDialog();
    };

    return (
        <div data-cy="DialogDataSource">
            <Dialog
                open={dialogOpen}
                onClose={toggleDialog}
                fullWidth
                aria-labelledby="form-dialog-title"
                className={styles.dialogContainer}
                data-cy="DialogDataSource-Dialog"
            >
                <ReportDialogTitle onClose={toggleDialog} children={dialogTitle} data-cy="DialogDataSource-onClose"/>
                <DialogContent>
                    <Typography gutterBottom data-cy="DialogDataSource-dialogContent">{dialogContent}</Typography>
                </DialogContent>
                <DialogActions className={styles.dialogAction}>
                    <Button
                        className={styles.btnOutline}
                        onClick={toggleDialog}
                        bgcolor={BUTTON.BGCOLOR.CLEAR}
                        color={BUTTON.COLOR.GREY}
                        data-cy="DialogDataSource-Cancel"
                    >
                        Cancel
                    </Button>
                    <Button onClick={onClick} bgcolor={BUTTON.BGCOLOR.ORANGE} color={BUTTON.COLOR.WHITE}  data-cy="DialogDataSource-dialogConfirm">
                        {dialogConfirm}
                    </Button>
                </DialogActions>
            </Dialog>
        </div>
    );
};

export default memo(DialogDataSource);
